import React from 'react'
import { useForm } from 'react-hook-form'
import { CreatableTagSelector } from 'components/CreatableTagSelector'

export function CreatableTagSelectorMock(): React.ReactElement {
  const { control, setError } = useForm<{ tags: any[] }>()
  return (
    <div className="w-full">
      <CreatableTagSelector
        name="tags"
        control={control}
        options={[
          { label: 'Enterprise', value: 1 },
          { label: 'Food & Bev', value: 2 },
          { label: 'High Priority', value: 3 },
        ]}
        setError={setError}
        label="Tags"
        placeholder="Add or create tags..."
      />
    </div>
  )
}
